import { useQueryUser } from 'graphql/query';

export const useMe = () => {
  const { data } = useQueryUser();
  return data?.user;
};
